package com.gastoncantera.intercom.push

import kotlinx.coroutines.flow.StateFlow

data class MissedCall(
    val title: String,
    val subtitle: String,
    val timeLabel: String,
)

/** Perdidas en memoria; solo Android alimenta la lista vía notificaciones. */
expect object MissedCalls {
    val popupTick: StateFlow<Int>
    fun pending(): List<MissedCall>
    suspend fun clear()
    fun onForeground()
}

/** Notificación de llamada mostrada (background). */
expect fun onIncomingCallNotificationShown(title: String, body: String)

/** Notificación cerrada sin acción del usuario (p. ej. portero colgó). */
expect fun onIncomingCallNotificationDismissed()

/** Usuario rechazó desde la notificación. */
expect fun onIncomingCallNotificationRejected()

/** Usuario atendió o rechazó desde la app (cierra ring activo sin contar perdida). */
expect fun notifyIncomingCallHandledByUser(callId: String?)
